import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({ name: 'assetsUrl', standalone: true })
export class AssetsUrlPipe implements PipeTransform {

    transform(path: string): string { return assetsUrl(path); }
}

function assetsUrl(path: string): string {

    if (!path) return '';
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${environment.ASSETS_HOST}${p}`;
}